import * as type from '../actions/types';

const initialState = {
  data: {},
  fetching: false,
  error: false,
  errorMessage: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case type.FETCH_RESTAURANT_PENDING: {
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
      };
    }

    case type.FETCH_RESTAURANT_SUCCESS: {
      return {
        ...state,
        data: { ...action.payload },
        fetching: false,
        error: false,
        errorMessage: '',
      };
    }

    case type.FETCH_RESTAURANT_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    }

    case type.UPDATE_RESTAURANT_VERSION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        fetching: false,
        error: false,
        errorMessage: '',
      };
    }

    case type.SET_POS_ID_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
